import { injectBaseConstantMethods } from "./BaseConstants"

const UserRoles = {
   User: "USER",
   Admin: "ADMIN",
   Executive: "EXECUTIVE",
   SuperAdmin: "SUPER_ADMIN",
   Production: "PRODUCTION",
   Department: "DEPARTMENT_MANAGER",
   Finance: "FINANCE_MANAGER",
   Warehouse: "WAREHOUSE_MANAGER",
   Marketing: "MARKETING_MANAGER",
   PlantManager: "PLANT_MANAGER",
   AssistantPlantManager: "ASSISTANT_PLANT_MANAGER",
   FrontOffice: "FRONT_OFFICE",
}

export const MANAGER_ROLES = [
   UserRoles.PlantManager,
   UserRoles.AssistantPlantManager,
]

const displayTextKeys = {
   [UserRoles.Admin]: "Admin",
   [UserRoles.SuperAdmin]: "Super Admin",
   [UserRoles.Department]: "Department Manager",
   [UserRoles.Executive]: "Executive",
   [UserRoles.Finance]: "Finance Manager",
   [UserRoles.Production]: "Production Manager",
   [UserRoles.User]: "User",
   [UserRoles.Warehouse]: "Warehouse Manager",
   [UserRoles.Marketing]: "Marketing Manager",
   [UserRoles.PlantManager]: "Plant Manager",
   [UserRoles.AssistantPlantManager]: "Asst. Plant Manager",
   [UserRoles.FrontOffice]: "Front Office",
}

const labelClass = {
   [UserRoles.Admin]: "admin-role",
   [UserRoles.SuperAdmin]: "super-admin-role",
   [UserRoles.Department]: "department-role",
   [UserRoles.Executive]: "executive-role",
   [UserRoles.Finance]: "finance-role",
   [UserRoles.Production]: "production-role",
   [UserRoles.User]: "user-role",
   [UserRoles.Warehouse]: "warehouse-role",
   [UserRoles.Marketing]: "marketing-role",
   [UserRoles.PlantManager]: "plant-manager",
   [UserRoles.AssistantPlantManager]: "assistant-plant-manager",
   [UserRoles.FrontOffice]: "front-office",
}

export default injectBaseConstantMethods(UserRoles, displayTextKeys, labelClass)
export {
   displayTextKeys as rolesDisplayTextKeys,
   labelClass as rolesLabelClass,
}
